/**
 * Tiny dev-only logger for non-fatal errors we intentionally swallow.
 *
 * Rationale:
 *   BlinkLink swallows a lot of exceptions on purpose (WS disconnects,
 *   best-effort presence pings, stale-read comments on expired vibes, private-mode
 *   localStorage denial, etc.) — surfacing those as toasts would flood users.
 *   But total silence hurts debugging, so we log to the console under a namespace
 *   only in non-production builds.
 *
 * Prod calls are cheap: NODE_ENV check short-circuits before any work.
 */
const IS_PROD =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV === "production";

export function logSwallow(scope, err, extra) {
  if (IS_PROD) return;
  console.debug(`[bl:${scope}]`, err?.message || err, extra || "");
}

export default logSwallow;
